import React from 'react';
import { isSafari } from 'react-device-detect';
import { useUpdateEffect } from 'react-use';
import { useEditorStore } from '../editor-store';

export const SafariRootSelectionClassFixer = () => {
  const shouldUseSafariSelectionFix = useEditorStore((state) => isSafari && state.isDraggingSomethingOnEditor);
  useUpdateEffect(() => {
    const appBodyElement = document.getElementById('app-body');
    if (!appBodyElement) {
      return;
    }
    if (shouldUseSafariSelectionFix) {
      appBodyElement.classList.add('select-none-safari-fix');
    } else if (!shouldUseSafariSelectionFix) {
      appBodyElement.classList.remove('select-none-safari-fix');
    }
  }, [shouldUseSafariSelectionFix]);
  return null;
};
